import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import { useCustomSearchParams } from "../../hooks/useCustomSearchParams";
import Logo from "../../styles/img/CompliNYC-Logo.png";
import "../SurveyScan/signature.scss";
import EnterSurveyForm from "../LL55/components/SurveyResponse/EnterSurveyForm";

function LL55ScanSurvey() {
  const [survey, setSurvey] = useCustomSearchParams("survey");
  const [token, setToken] = useCustomSearchParams("token");

  return (
    <div className="scan-container">
      <DialogTitle
        sx={{ m: 0, padding: "16px", bgcolor: "#f5f5f9", lineHeight: "1" }}
        id="responsive-dialog-title"
        className=""
      >
        <div className="d-flex align-items-center">
          <img
            src={Logo}
            alt="Sofmen"
            className="cursor-pointer raza-logo-scan-page"
            // onClick={() => redirect("/")}
          />
          <div className="lead-paint-comp-header ml-4">
            <p>Annual Notice Compliance - LL55 Investigation</p>
          </div>
          {/* <div className="verticle-div">
            <img src={Horizontal} />
          </div> */}
        </div>
      </DialogTitle>
      <div className="lead-compliance-scan-form">
        {/* <LongFormDialog
        open={true}
        handleClose={() => {}}
        title={"Survey Response"}
        btnTitle={"Confirm"}
      > */}

        <EnterSurveyForm
          isFromQr={true}
          initialData={{ survey_id: survey, dates: new Date() }}
          token={token}
        />
        {/* </LongFormDialog> */}
      </div>
    </div>
  );
}

export default LL55ScanSurvey;
